import { OrderFilter } from 'models/order';

// Stored in the saved filters instead of a user id, so "My jobs" always means
// whoever is logged in, even on a shared lab computer.
export const MY_JOBS_TECHNICIAN_FILTER = 'ME';

export const NO_TECHNICIAN_FILTER = 'NONE';

export const resolveTechnicianFilter = (filters: OrderFilter, currentUserId: string): OrderFilter => {
    if (filters.technicianId !== MY_JOBS_TECHNICIAN_FILTER) {
        return filters;
    }
    return { ...filters, technicianId: currentUserId };
};
